export const getSizeLabel = (sizeObj) => {
  if (!sizeObj) return "";

  const label = sizeObj.displayName || sizeObj.name || "";

  if (sizeObj.tierCount && label) {
    const tierLabel =
      sizeObj.tierCount === 1 ? "1 tier" : `${sizeObj.tierCount} tiers`;
    return `${tierLabel} ${label}`;
  }

  return label;
};
